var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceNo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#676879",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23541 7.17475C7.94252 6.88185 7.46764 6.88185 7.17475 7.17475C6.88185 7.46764 6.88185 7.94251 7.17475 8.23541L8.93961 10.0003L7.17517 11.7647C6.88228 12.0576 6.88228 12.5325 7.17517 12.8254C7.46806 13.1183 7.94294 13.1183 8.23583 12.8254L10.0003 11.0609L11.7647 12.8254C12.0576 13.1183 12.5325 13.1183 12.8254 12.8254C13.1183 12.5325 13.1183 12.0576 12.8254 11.7647L11.0609 10.0003L12.8258 8.23541C13.1187 7.94251 13.1187 7.46764 12.8258 7.17475C12.5329 6.88185 12.058 6.88185 11.7651 7.17475L10.0003 8.93961L8.23541 7.17475Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceNo);
export default __webpack_public_path__ + "static/media/compliance-no.656cb1ed.svg";
export { ForwardRef as ReactComponent };